import React from 'react'
import { Typography, Tooltip } from 'antd'
import { PolicyAction, PolicyOperator } from 'src/types'
import { Empty as CssEmpty, Icon, RuleButtonNew } from './styles'
import { Button } from 'src/components/Ant'

interface ButtonAddNewProps {
  onClick: () => void
}

export function ButtonAddNew({ onClick }: ButtonAddNewProps) {
  return (
    <RuleButtonNew>
      <Button
        icon="plus"
        onClick={onClick}
        title="common.actions.add"
        type="primary"
      />
    </RuleButtonNew>
  )
}

export function Empty({ message }: { message: string }) {
  return <CssEmpty>{message}</CssEmpty>
}

interface PolicyRuleAlertIconProps {
  action: PolicyAction
  alert: string
  block: string
}

export function PolicyRuleAlertIcon({
  action,
  alert,
  block
}: PolicyRuleAlertIconProps) {
  if (action === PolicyAction.ALERT) {
    return (
      <Icon
        theme="twoTone"
        title={alert}
        twoToneColor="orange"
        type="warning"
      />
    )
  }
  return <Icon theme="twoTone" title={block} twoToneColor="red" type="stop" />
}

interface RecordTextProps {
  text?: string
}

export function RecordText({ text = '' }: RecordTextProps): JSX.Element {
  if (text?.length > 20) {
    return (
      <Tooltip title={text}>
        <Typography>{`${text.substring(0, 17)}...`}</Typography>
      </Tooltip>
    )
  }
  return <Typography>{text}</Typography>
}

export function SquareIcon({ square = false }: { square: boolean }) {
  if (square) {
    return <Icon type="check-square" />
  }

  return <Icon type="minus-square" />
}

export function tOperator(type: PolicyOperator) {
  let message

  switch (type) {
    case PolicyOperator.LESS_THAN:
      message = 'common.condition.less-than'
      break
    case PolicyOperator.LESS_THAN_OR_EQUAL_TO:
      message = 'common.condition.less-than-or-equal'
      break
    case PolicyOperator.EQUALS:
      message = 'common.condition.equal'
      break
    case PolicyOperator.GREATER_THAN_OR_EQUAL_TO:
      message = 'common.condition.greater-than-or-equal'
      break
    case PolicyOperator.GREATER_THAN:
      message = 'common.condition.greater-than'
      break
    default:
      message = 'common.condition.unknown'
  }

  return message
}
